import React, { useEffect } from "react";
import { Carousel } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

const AnimatedCarousel = ({ slides }) => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const keyframes = `
    @keyframes zoomInOut {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }
  `;

  const carouselItemStyle = {
    position: "relative",
  };

  const imageStyle = {
    width: "100%",
    height: "550px",
    objectFit: "cover",
    animation: "zoomInOut 5s ease-in-out infinite",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1,
  };

  const captionStyle = {
    zIndex: 2,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "left",
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <style>{keyframes}</style>
      <Carousel fade controls indicators interval={2000} pause={false}>
        {slides.map((slide, index) => (
          <Carousel.Item
            key={index}
            data-aos="zoom-in"
            style={carouselItemStyle}
          >
            <img
              src={slide.img}
              alt={`Slide ${index}`}
              style={imageStyle}
              className="d-block w-100"
            />
            <div style={overlayStyle}></div>
            <div style={captionStyle} className="container">
              <h1 className="font-size" data-aos="fade-down">
                {slide.title}
              </h1>
              <div data-aos="fade-left">
                <h1 className="middle-text">{slide.subtitle}</h1>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default AnimatedCarousel;
